import { Text } from '@innovyze/stylovyze/lib/components';
import React from 'react';
import { useConsumeWeaveTheme } from '../../../theme/WeaveContext';
import styled from 'styled-components';
export function getOrgText({ companySettings, defaultSite, defaultSiteName, isForgeFlow, }) {
    // forge
    if (isForgeFlow) {
        return defaultSiteName ? defaultSiteName : defaultSite;
    }
    // auth0
    return (companySettings.organizationName || companySettings.organization || '');
}
const StyledText = styled(Text) `
	color: ${({ textColor }) => textColor};
`;
export default function OrgText({ orgListComponents, openMenu, orgText, }) {
    const textClick = orgListComponents?.length ? openMenu : null;
    const { isWeaveTheme, resolvedRoles } = useConsumeWeaveTheme();
    return (React.createElement(StyledText, { textColor: isWeaveTheme && resolvedRoles['colorScheme.text.default'], color: isWeaveTheme && resolvedRoles['colorScheme.text.default']
            ? 'textSecondary'
            : 'secondary', variant: 'text-large', onClick: textClick, dataCy: "org-switcher" }, orgText));
}
